export interface IntegerDatatypeInterface extends Number {
  data?: number;
}

export class IntegerDatatypeClass extends Number
  implements IntegerDatatypeInterface {
  data?: number;
}
